export function parseCloudMode(value: string | undefined): boolean {
  if (value === undefined || value === 'false') return false;
  if (value === 'true') return true;
  throw new Error('VITE_KIOSK_CLOUD_MODE must be true or false');
}

export const CLOUD_MODE = parseCloudMode(import.meta.env.VITE_KIOSK_CLOUD_MODE);
